
export default {
    getActivityConfigurations: (state) => state.activityConfigurations,
}